<template>
    <div>
        <Transition name="fade">
            <div
                v-if="items.length > 0"
                id="accordion"
                class="col-sm-12 list-content result-table"
            >
                <vue3-datatable
                    ref="resultTable"
                    :rows="items"
                    :columns="fields"
                    :pagination="false"
                    :sticky-header="true"
                    :height="items.length > 8 ? '50vh': '100%'"
                    :sortable="true"
                    skin="bh-table-compact"
                    row-class="routa-table-row"
                    cell-class="routa-table-cell"
                    @row-click="emitDetails"
                >
                    <template #empty>
                        <div class="text-center my-2">
                            {{ $t('common.no_results') }}
                        </div>
                    </template>
                    <template #event_time="row">{{ row.value.time }}</template>
                    <template #event_type="row">
                        {{ getDangerTypeName(row.value.event_type) }}
                    </template>
                </vue3-datatable>
            </div>
        </Transition>
    </div>
</template>

<script>
import {timeUtils} from '../mixins/TimeUtils'
import {dangerHelper} from '../mixins/DangerMixin'
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'DangerReportList',
    mixins: [timeUtils, dangerHelper],
    components: {Vue3Datatable},
    props: {
        results: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data() {
        return {
            sortBy: 'start_time',
            sortDesc: true,
            fields: [
                {field: 'id', title: this.$t('danger_report.report_id'), sort: true, headerClass: 'routa-table-header', type: 'number' },
                {field: 'reporter', title: this.$t('danger_report.reporter'), sort: true, headerClass: 'routa-table-header' },
                {field: 'reporting_company', title: this.$t('danger_report.reporting_company'), sort: true, headerClass: 'routa-table-header' },
                {field: 'event_time', title: this.$t('danger_report.event_time'), sort: true, headerClass: 'routa-table-header' },
                {field: 'event_type', title: this.$t('danger_report.event_type'), sort: true, headerClass: 'routa-table-header' },
                // {field: 'location', title: this.$t('danger_report.location'), sort: true, headerClass: 'routa-table-header' },
                {field: 'contract', title: this.$t('danger_report.contract'), sort: true, headerClass: 'routa-table-header' },
                {field: 'description', title: this.$t('danger_report.description'), sort: true, headerClass: 'routa-table-header' },
                {field: 'handled', title: this.$t('danger_report.handled'), sort: true, headerClass: 'routa-table-header' },
                {field: 'handled_by', title: this.$t('danger_report.handled_by'), sort: true, headerClass: 'routa-table-header' },
                {field: 'handling_note', title: this.$t('danger_report.note'), sort: false, headerClass: 'routa-table-header' },
            ],
            items: []
        }
    },
    watch: {
        results: function () {
            this.initTableItems()
        }
    },
    mounted: function () {
        this.initTableItems()
    },
    methods: {
        initTableItems: function () {
            this.items = []
            let temp = []
            this.results.forEach(function (item) {
                temp.push(
                    {
                        id: item.id,
                        event_time: new Date(item.event_time).getTime(),
                        time: this.toLocalTime(item.event_time),
                        reporting_company: item.reporting_company.name,
                        event_type: item.event_type,
                        reporter: item.reporter.first_name + ' ' + item.reporter.last_name,
                        description: item.description,
                        // name or ID?
                        contract: item.contract ? item.contract.name : "",
                        location: item.location,
                        handled: item.handled ? this.$t('common.yes') : this.$t('common.no'),
                        handled_by: item.handled_by ? item.handled_by.last_name + ' ' + item.handled_by.first_name : '-',
                        handling_note: item.handling_note
                    }
                )
            }, this)
            this.$nextTick(() => this.items = temp)
        },
        emitDetails: function (details) {
            let report = this.results.find(item => item.id === details.id)
            this.$emit('details', report)
        }
    }
}
</script>
